var _defs, _rect, _text, _rect2, _text2, _text3, _rect3, _text4, _text5, _rect4, _text6, _text7, _rect5, _text8, _text9, _rect6, _text10, _text11, _rect7, _text12, _text13, _rect8, _text14, _rect9, _text15, _text16, _rect10, _text17, _text18, _rect11, _text19, _text20, _rect12, _text21, _text22, _rect13, _text23, _text24, _g, _text25, _text26, _text27, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _text28, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCnIntegrationDiagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1600 1000",
    width: 1600,
    height: 1000,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("marker", {
    id: "arrow",
    viewBox: "0 0 10 10",
    refX: 9,
    refY: 5,
    markerWidth: 7,
    markerHeight: 7,
    orient: "auto-start-reverse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L10,5 L0,10 z",
    fill: "#9AA0BC"
  })), /*#__PURE__*/React.createElement("marker", {
    id: "arrow-amber",
    viewBox: "0 0 10 10",
    refX: 9,
    refY: 5,
    markerWidth: 7,
    markerHeight: 7,
    orient: "auto-start-reverse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L10,5 L0,10 z",
    fill: "#C4CDFF"
  })), /*#__PURE__*/React.createElement("style", null, "\n      .sans { font-family: -apple-system, 'Helvetica Neue', Arial, sans-serif; }\n      .mono { font-family: 'SF Mono', Menlo, Consolas, monospace; letter-spacing: 0.08em; }\n      .box { fill: #121526; stroke: #232640; stroke-width: 2; }\n      .org { fill: #0E101C; stroke: #2A2D45; stroke-width: 2; }\n      .title { fill: #EEF0FA; font-size: 30px; font-weight: 600; }\n      .label { fill: #EEF0FA; font-size: 24px; font-weight: 500; }\n      .sub { fill: #9AA0BC; font-size: 19px; }\n      .tag { fill: #C4CDFF; font-size: 16px; }\n      .muted { fill: #9AA0BC; font-size: 16px; }\n      .flow { stroke: #9AA0BC; stroke-width: 2.5; fill: none; }\n      .flow-amber { stroke: #C4CDFF; stroke-width: 2.5; fill: none; }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1600,
    height: 1000,
    fill: "#0C0E17"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 80,
    y: 92,
    className: "mono tag"
  }, "CN \u2194 METROLINX \xB7 LIVE RAIL DATA")), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 200,
    width: 300,
    height: 560,
    rx: 14,
    className: "org"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 112,
    y: 258,
    className: "sans title"
  }, "CN")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 112,
    y: 292,
    className: "sans sub"
  }, "Freight rail network")), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 340,
    width: 236,
    height: 120,
    rx: 10,
    className: "box"
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 134,
    y: 392,
    className: "sans label"
  }, "Live rail events")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 134,
    y: 424,
    className: "sans sub"
  }, "published out")), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 560,
    width: 236,
    height: 120,
    rx: 10,
    className: "box"
  })), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 134,
    y: 612,
    className: "sans label"
  }, "Updates in")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 134,
    y: 644,
    className: "sans sub"
  }, "from Metrolinx")), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 1220,
    y: 200,
    width: 300,
    height: 560,
    rx: 14,
    className: "org"
  })), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 1252,
    y: 258,
    className: "sans title"
  }, "Metrolinx")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 1252,
    y: 292,
    className: "sans sub"
  }, "GO Transit network")), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 1252,
    y: 340,
    width: 236,
    height: 120,
    rx: 10,
    className: "box"
  })), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 1274,
    y: 392,
    className: "sans label"
  }, "Updates in")), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 1274,
    y: 424,
    className: "sans sub"
  }, "from CN")), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 1252,
    y: 560,
    width: 236,
    height: 120,
    rx: 10,
    className: "box"
  })), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 1274,
    y: 612,
    className: "sans label"
  }, "Live rail events")), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 1274,
    y: 644,
    className: "sans sub"
  }, "published out")), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 450,
    y: 160,
    width: 700,
    height: 640,
    rx: 16,
    fill: "none",
    stroke: "#C4CDFF",
    strokeOpacity: 0.55,
    strokeWidth: 2,
    strokeDasharray: "10 8"
  })), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 480,
    y: 202,
    className: "mono tag"
  }, "AZURE CONTAINER APPS \xB7 5 MICROSERVICES")), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 490,
    y: 340,
    width: 170,
    height: 120,
    rx: 10,
    className: "box"
  })), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    x: 512,
    y: 392,
    className: "sans label"
  }, "Ingest")), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    x: 512,
    y: 424,
    className: "sans sub"
  }, "CN side")), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 940,
    y: 340,
    width: 170,
    height: 120,
    rx: 10,
    className: "box"
  })), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    x: 962,
    y: 392,
    className: "sans label"
  }, "Deliver")), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    x: 962,
    y: 424,
    className: "sans sub"
  }, "Metrolinx side")), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 940,
    y: 560,
    width: 170,
    height: 120,
    rx: 10,
    className: "box"
  })), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    x: 962,
    y: 612,
    className: "sans label"
  }, "Ingest")), _text20 || (_text20 = /*#__PURE__*/React.createElement("text", {
    x: 962,
    y: 644,
    className: "sans sub"
  }, "Metrolinx side")), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 490,
    y: 560,
    width: 170,
    height: 120,
    rx: 10,
    className: "box"
  })), _text21 || (_text21 = /*#__PURE__*/React.createElement("text", {
    x: 512,
    y: 612,
    className: "sans label"
  }, "Deliver")), _text22 || (_text22 = /*#__PURE__*/React.createElement("text", {
    x: 512,
    y: 644,
    className: "sans sub"
  }, "CN side")), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 705,
    y: 300,
    width: 190,
    height: 420,
    rx: 12,
    fill: "#141733",
    stroke: "#C4CDFF",
    strokeWidth: 2
  })), _text23 || (_text23 = /*#__PURE__*/React.createElement("text", {
    x: 800,
    y: 360,
    textAnchor: "middle",
    className: "sans label"
  }, "RabbitMQ")), _text24 || (_text24 = /*#__PURE__*/React.createElement("text", {
    x: 800,
    y: 394,
    textAnchor: "middle",
    className: "sans sub"
  }, "event-driven")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#C4CDFF",
    fillOpacity: 0.8
  }, /*#__PURE__*/React.createElement("rect", {
    x: 735,
    y: 430,
    width: 130,
    height: 10,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 735,
    y: 450,
    width: 130,
    height: 10,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 735,
    y: 470,
    width: 130,
    height: 10,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 735,
    y: 490,
    width: 130,
    height: 10,
    rx: 3
  }))), _text25 || (_text25 = /*#__PURE__*/React.createElement("text", {
    x: 800,
    y: 548,
    textAnchor: "middle",
    className: "sans label"
  }, "20 queues")), _text26 || (_text26 = /*#__PURE__*/React.createElement("text", {
    x: 800,
    y: 592,
    textAnchor: "middle",
    className: "sans label"
  }, "10 consumers")), _text27 || (_text27 = /*#__PURE__*/React.createElement("text", {
    x: 800,
    y: 650,
    textAnchor: "middle",
    className: "sans sub"
  }, "routing per org")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M348 400 H486",
    className: "flow",
    markerEnd: "url(#arrow)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M660 400 H701",
    className: "flow-amber",
    markerEnd: "url(#arrow-amber)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M895 400 H936",
    className: "flow-amber",
    markerEnd: "url(#arrow-amber)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1110 400 H1248",
    className: "flow",
    markerEnd: "url(#arrow)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1252 620 H1114",
    className: "flow",
    markerEnd: "url(#arrow)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M940 620 H899",
    className: "flow-amber",
    markerEnd: "url(#arrow-amber)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M705 620 H664",
    className: "flow-amber",
    markerEnd: "url(#arrow-amber)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M490 620 H352",
    className: "flow",
    markerEnd: "url(#arrow)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M470 510 H700 M900 510 H1130",
    stroke: "#2A2D45",
    strokeWidth: 2,
    strokeDasharray: "4 8"
  })), _text28 || (_text28 = /*#__PURE__*/React.createElement("text", {
    x: 480,
    y: 540,
    className: "mono muted"
  }, "ORG ISOLATION")), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "mono muted"
  }, /*#__PURE__*/React.createElement("text", {
    x: 80,
    y: 890
  }, "UPDATES EVERY 10\u201330 S"), /*#__PURE__*/React.createElement("text", {
    x: 500,
    y: 890
  }, "NO SHARED DATABASE"), /*#__PURE__*/React.createElement("text", {
    x: 880,
    y: 890
  }, "KUBERNETES AT THE EDGES"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCnIntegrationDiagram);
export default __webpack_public_path__ + "static/media/cn-integration-diagram.e1d786be615f44d80d58e68f2b58b26d.svg";
export { ForwardRef as ReactComponent };